import { BOOKINGFLIGHT, CANCELBOOKINGFLIGHT } from "./actionTypes";

const initialState = [];



const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOKINGFLIGHT:
      return [...state, action.payload];
    case CANCELBOOKINGFLIGHT:
      return [...state.filter(item => item.id != action.payload)];

    default:
      return state;
  }
};

export default bookingReducer;
